import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../apiSlice'
import { ISimulationQuestionScoreResponse, ISimulationSendToBeck } from './model'

export const simulationApi = createApi({
  reducerPath: 'simulationApi/api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    simulationQuestionScore: build.mutation<
      ISimulationQuestionScoreResponse,
      ISimulationSendToBeck
    >({
      query: (data: ISimulationSendToBeck) => ({
        url: 'admin/api-simulation-question-score',
        method: 'POST',
        body: data
      })
    })
  })
})

export const { useSimulationQuestionScoreMutation } = simulationApi
